import { ApiOptions } from '../../api-options.decorator';

import { ApiBaseMidBack } from './base';
import { GlobalSearchResultViewModel } from './types/globalSearchResultViewModel';

/**
 * @internal
 */
export class ApiSearch extends ApiBaseMidBack {
  @ApiOptions({ channel: 'search.get' })
  getSearch(search: string) {
    return this.get<GlobalSearchResultViewModel[]>(`/global-search/${encodeURIComponent(search)}`);
  }
}
